import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const REGION_KEY_BY_LABEL = {
  'Bali (Indonesia)': 'bali',
  'Northern Cyprus': 'northernCyprus',
  Vietnam: 'vietnam',
  Maldives: 'maldives'
};

export const mediaUrl = (url) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `${BACKEND_URL}${url}`;
};

export const toProperty = (project) => ({
  id: project.id,
  legacyId: project.legacy_id,
  title: project.title,
  location: project.region,
  address: project.address,
  type: project.type,
  price: project.price,
  apartmentArea: project.apartment_area,
  villaArea: project.villa_area,
  description: project.description,
  descriptions: project.descriptions || {},
  images: (project.images || []).map(mediaUrl),
  image: mediaUrl((project.images || [])[0]),
  featured: project.featured
});

export const resolveDescription = (property, t, language) => {
  const legacy = property.legacyId ?? property.id;
  const fromI18n = t(`properties.${legacy}.description`, { defaultValue: '' });
  if (fromI18n) return fromI18n;
  const lang = (language || 'en').slice(0, 2);
  return property.descriptions?.[lang] || property.description;
};

export const useProjects = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${BACKEND_URL}/api/projects`)
      .then(({ data }) => {
        if (active) setProperties(data.map(toProperty));
      })
      .catch((error) => console.error('Could not load projects:', error))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { properties, loading };
};

/** Regions that still have at least one published project - everything else is delisted. */
export const useActiveRegions = () => {
  const { properties, loading } = useProjects();
  const labels = [...new Set(properties.map((p) => p.location))];
  return {
    loading,
    labels,
    keys: labels.map((label) => REGION_KEY_BY_LABEL[label]).filter(Boolean),
    hasRegion: (label) => labels.includes(label)
  };
};
